import { HttpResult } from "widgets-for-react";
import { EventPage } from "../../cmsPageState";
import { transformEventPageData } from "../../sharepointPageApi/transformers/pageDataToPage";
import { EventPageData } from "../../sharepointPageApi/types/pageData";

export interface EventPageDataWithCount {
  Pages: EventPageData[]
  Count: number
}

export type EventPageWithCount = {
  Pages: EventPage[]
  Count: number
}

export const allEventsBlockApi = async (teaser: boolean): Promise<HttpResult<EventPageWithCount>> => {
    const res = await fetch(`/api/v1/pages/events?${new URLSearchParams({teaser: teaser.toString()}).toString()}`);

    if (!res.ok)
      return {
        kind: 'failed',
        status: res.status,
      }

    const data: EventPageDataWithCount = await res.json();

    return {
      kind: 'result',
      status: 200,
      value: { Pages: data.Pages.map(x => transformEventPageData(x)), Count: data.Count }
    };
  }
